export default {
  toasts: {
    failed_to_create_website: 'Error al crear el sitio web',
  },
  steps: {
    information: 'Información',
    template: 'Plantilla',
  },
  buttons: {
    next: 'Siguiente',
    previous: 'Anterior',
    create_website: 'Crear sitio web',
    preview_about_us: 'Sobre nosotros (Vista previa)',
  },
  about_us_modal: {
    title: 'Sobre nosotros (Vista previa)',
  },
  error_messages: {
    missing_fields:
      'Faltan algunos campos obligatorios. Por favor, completa toda la información necesaria antes de continuar.',
  },
};
